import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenSv = () => {
    return <AddStartpageComToYourHomeScreen languageCode="sv" />
}

export default AddStartpageComToYourHomeScreenSv
